export const UNKNOWN_ERROR_MESSAGE = 'Unknown error message';

// timeout in miliseconds
export const API_TIMEOUT = 11000;

export const API_TIMEOUT_ERROR = 'API_TIMEOUT_ERROR';



// WEBPACK FOOTER //
// ./app/sdk/common/constants.js